import { combineReducers, configureStore } from '@reduxjs/toolkit'
import authenticationReducer from './features/authenticationSlice/authenticationSlice'
import storage from 'redux-persist/lib/storage'
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE, persistReducer } from 'redux-persist'


const persistConfig = {
    timeout: 100,
    key: "root",
    version: 1,
    storage,
    whitelist: ["authentication"]
  }
  
  const reducer = combineReducers({
    authentication: authenticationReducer
  })
  
  const persistedReducer = persistReducer(persistConfig, reducer)
  
  export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
          serializableCheck: {
              ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
          },
      }),
  })
